import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {formatDate, formatToDollar, runAfterLoadSession} from "../../utils/Utility";
import {getCredit} from "../../utils/API";
import HeaderApp from "../home/HeaderApp";
import QuestionModal from "../utils/QuestionModal";
import KeyVal from "../shared/KeyVal";

class Transactions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            credits: [],

        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            getCredit((res) => {
                this.setState({credits: res})
            })
        })

    }

    render() {
        return (
            <div className="">
                <HeaderApp name="Transactions" back="/hom"/>
                <div className="main-app">
                    <div>
                        <div className="mt-3 body-app">
                            <div>
                                {this.state.credits.length === 0 &&
                                <span className="d-block text-center mb-4">You don't have any transactions yet</span>}
                                {
                                    this.state.credits.map((c,i) =>
                                        <div key={i} className="shadow-black mb-3 p-3" style={{backgroundColor: c.increase ? '#ebffeb' : '#ffeded'}}>
                                            <KeyVal name="date" value={formatDate(new Date(c.creationDateNumber))}/>
                                            <KeyVal name="description" value={c.description}/>
                                            <KeyVal name="amount" value={formatToDollar(c.amount)}/>
                                            <KeyVal name="type" value={c.increase ? 'increase' : 'decrease'}/>
                                        </div>)
                                }
                            </div>
                        </div>

                    </div>

                    <QuestionModal show={this.state.showRemoveFav}
                                   onHide={() => this.setState({showRemoveFav: false})}
                                   acceptTitle="Yes"
                                   rejectTitle="No"
                                   onReject={() => this.setState({showRemoveFav: false})}
                                   hideButton={this.state.apiRemoveFav}
                                   onAccept={this.removeFavorite}
                    >
                        <div className="text-center p-3">
                            <span>{'Are you sure to remove favorite?'}</span>
                        </div>
                    </QuestionModal>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        tutorEnv: state.param[Objects.tutorEnv],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transactions)
